<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs >

              <BTab :title="$t('returnProducts')">
              <ProductReturnInventory/>
              </BTab>
              <BTab :title="$t('TempReturnProductsList')">
                <ReturnDocListTemp/>
              </BTab>
              <BTab :title="$t('FinalReturnProductsList')">
              <ReturnDocListFinal/>
              </BTab>
              <BTab :title="$t('ItemsReturn')">
                <ItemsProductsReturn/>
              </BTab>

              <BTab :title="$t('damageProducts')">
                <DamageProducts/>
              </BTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import moment from 'moment-jalaali'
import BTabs from "../../tabs/BTabs";
import InWayInvetoryOrders from './InWayInvetoryOrders'
import InventoryAllOrderList from "./InventoryAllOrderList";
import ExitInsiteOrders from "@/views/panel/inventory/ExitInsiteOrders";
import DamageProducts from "./DamageProducts";
import ReturnDocListFinal from "./ReturnDocListFinal";
import ReturnDocListTemp from "./ReturnDocListTemp";
var items = [];
import ProductReturnInventory from "./ProductReturnInventory";
import BeetweenInventory from "./BeetweenInventory";
import ItemsProductsReturn from "./ItemsProductsReturn";
import BTab from "../../tabs/BTab";
export default {
  name: 'Login',
  components: {
    BTab,
    BeetweenInventory,
    ReturnDocListFinal,
    ReturnDocListTemp,
    DamageProducts,
    ExitInsiteOrders,
    BTabs,
    InWayInvetoryOrders,
    InventoryAllOrderList,
    ProductReturnInventory,
    ItemsProductsReturn
  },
  data() {
    return {

    }
  },
  mounted() {

  }, watch: {


  },
  methods: {

  }
}

</script>
